import "primereact/resources/themes/lara-light-cyan/theme.css";
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./Login";
import Home from "./Home";
import SignUp from "./SignUp";
import LostPass from "./LostPass";
import AuthProvider from "./auth/AuthProvider";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path='/signup' element={<SignUp />} />
            <Route path='/lostpass' element={<LostPass />} />
          </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
